import { CaseStudies } from './CaseStudies';
export default CaseStudies;
